import React from "react";
import { Navigate } from "react-router-dom";
import { Avatar, Breadcrumb, Button, Col, Divider, Form, Input, Row, Typography, Upload, message } from "antd";


import { POST_API, POST_CATCH, getToken, getUPLOADAPI } from "../services/hello-api";

import Pageload from "../components/Pageload";
import { IoCameraOutline } from "react-icons/io5";

class Perfil extends React.Component {

    state = { _loading: true, _navigate: false, _user: null, _menu: false }

    componentDidMount = () => {
        this.onView()
    }

    onView = () => {
        this.setState({_loading: true})
        if (getToken()) {
            POST_API('/credential/verify.php', { token: getToken() }).then(rs => rs.json()).then(res => {
                if (!res.return) {
                    this.setState({_navigate: true})
                } else {
                    this.setState({_user: res.user})
                }
            }).catch(() => POST_CATCH()).finally(() => {
                this.setState({_loading: false})
            })
        } else {
            this.setState({_navigate: true})
        }
    }

    onSend = (values) => {
        this.setState({_screen: true})
        POST_API('/credential/self-pass.php', { token: getToken(), master: JSON.stringify(values) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.onView()
                message.success({ content: res.msg, key: 'screen' })
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => {
            message.error({ content: 'Não foi possível estabelecer uma conexão com o sistema', key: 'screen' })
        }).finally(() => this.setState({_screen: false}))
    }

    onSendData = (values) => {
        this.setState({_screen: true})
        POST_API('/credential/self-save.php', { token: getToken(), master: JSON.stringify(values) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                message.success({ content: res.msg, key: 'screen' })
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => {
            message.error({ content: 'Não foi possível estabelecer uma conexão com o sistema', key: 'screen' })
        }).finally(() => this.setState({_screen: false}))
    }

    onChangePic = (value) => {
        if (value.file.response?.url) {
            this.setState({_screen: true})
            POST_API('/credential/self-save.php', { token: getToken(), master: JSON.stringify({AVATAR: value.file.response?.url}) }).then(rs => rs.json()).then(res => {
                if (res.return) {
                    message.success({ content: res.msg, key: 'screen' })
                } else {
                    message.warning({ content: res.msg, key: 'screen' })
                }
            }).catch(() => {
                message.error({ content: 'Não foi possível estabelecer uma conexão com o sistema', key: 'screen' })
            }).finally(() => this.onView())
        }
    }

    render = ( ) => {

        const routes = [
            {title: <Typography className="page-bread active">Meu Perfil</Typography>}
        ]

        if (this.state._navigate) return <Navigate to="/" />

        if (this.state._user === null || this.state._loading) return <Pageload />

        return (
            <Row>
                <Col xs={24} md={0}>
                    <Breadcrumb items={routes} className="bread-page" />
                </Col>
                <Col xs={0} md={24} className="page-header">
                    <Row className="table__row_table" gutter={[8,8]}>
                        <Col span={24}>
                            <Breadcrumb items={routes} />
                        </Col>
                    </Row>
                </Col>
                <Col span={24} className="page-content">
                    <Row gutter={[16,16]}>
                        <Col xs={24} md={8}>
                            <Row className="table__row_table" justify="center" align={'middle'} style={{flexDirection:  'column'}}>
                                <Avatar size={200} shape="circle" src={this.state._user?.AVATAR} style={{marginBottom: 12}}/>
                                <Upload maxCount={1} showUploadList={false} accept="image/jpg,image/jpeg,image/png" action={getUPLOADAPI} onChange={this.onChangePic} className={`admin-profile-upload`}>
                                    <Button shape="circle" className="btn-nav" type="default"><IoCameraOutline size={20} /></Button>
                                </Upload>
                                <Divider />
                                <Form onFinish={this.onSend}>
                                    <Form.Item label="Senha atual" name="OLD_PASSWORD" rules={[{required: true, message: 'Campo obrigatório!'}]}>
                                        <Input type="password"/>
                                    </Form.Item>
                                    <Form.Item label="Nova senha" name="NEW_PASSWORD" rules={[{required: true, message: 'Campo obrigatório!'}]}>
                                        <Input type="password"/>
                                    </Form.Item>
                                    <Form.Item>
                                        <Button shape="round" htmlType="submit" className="btn-primary" block type="primary">Alterar Senha</Button>
                                    </Form.Item>
                                </Form>
                            </Row>
                        </Col>
                        <Col xs={24} md={16}>
                            <Form onFinish={this.onSendData} layout="vertical" initialValues={this.state._user}>
                                <Row className="table__row_table" gutter={[8,8]}>
                                    <Col md={12} xs={24}>
                                        <Form.Item label="Nome" name="NAME" rules={[{required: true, message: 'Campo obrigatório!'}]}>
                                            <Input type="text"/>
                                        </Form.Item>
                                    </Col>
                                    <Col md={12} xs={24}>
                                        <Form.Item label="Nickname" name="NICK">
                                            <Input type="text"/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Button loading={this.state._loading} htmlType="submit" type="primary" shape="round" style={{float: 'right'}}>Salvar</Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }

}

export default Perfil;